<!-- =========================================================================================
File Name: RegisterJWT.vue
Description: Register Page for JWT
----------------------------------------------------------------------------------------
========================================================================================== -->


<template>
  <div class="clearfix">
    <vx-form layout="h" v-slot="{handleSubmit}">
      <form-item required hideLabel>
        <vs-input
          class="w-full"
          v-model="form.phone"
          icon-no-border
          icon="iconfont icon-phone"
          icon-pack="feather"
          placeholder="手机号"
        />
      </form-item>
      <form-item required hideLabel class="mt-5">
        <vs-row>
          <vs-col vs-w="6">
            <vs-input
              type="text"
              icon-no-border
              icon="iconfont icon-notification"
              icon-pack="feather"
              placeholder="验证码"
              v-model="form.code"
              class="w-full"
            />
          </vs-col>
          <vs-col vs-w="6" vs-align="left">
            <vs-button type="border" size="small" style="margin-top: 3px;" class="ml-1" @click="sendSms" :disabled="!!disabledSendTimeout">
              发送验证码
              <span v-if="disabledSendTimeout"> ({{disabledSendTimeout}}) </span>
            </vs-button>
          </vs-col>
        </vs-row>


      </form-item>
      <form-item required hideLabel class="mt-5">
        <vs-input
          type="password"
          name="password"
          icon-no-border
          icon="iconfont icon-lock"
          icon-pack="feather"
          placeholder="密码"
          v-model="form.password"
          class="w-full"
          @keypress.enter="handleSubmit(loginJWT)"
        />
      </form-item>
      <form-item required hideLabel class="mt-5">
        <vs-input
          type="password"
          name="password"
          icon-no-border
          icon="iconfont icon-lock"
          icon-pack="feather"
          placeholder="确认密码"
          v-model="form.confirmPassword"
          class="w-full"
        />
      </form-item>
      <div class="whitespace-no-wrap flex mt-6">
        <vs-checkbox v-model="agree">我同意</vs-checkbox>
        <a href class="text-primary" @click.stop.prevent="$modal('registerUserProto')">《智慧溯源网使用协议及服务条款》</a>
      </div>
      <div class="flex flex-wrap justify-between mb-3">
        <vs-button type="border" to="/pages/login" class="mt-6">返回登录</vs-button>
        <vs-button class="float-right mt-6" @click="handleSubmit(registerUserJWt)">注册新账户</vs-button>
      </div>
    </vx-form>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        form: {
          phone: '',
          code: '',
          password: '',
          confirmPassword: '',
        },
        agree: true,
        disabledSendTimeout: 0,
      }
    },
    methods: {
      startSendTimeout() {
        this.disabledSendTimeout = 60
        this.interval = setInterval(() => {
          this.disabledSendTimeout--
          if (this.disabledSendTimeout <= 0) {
            this.interval && clearInterval(this.interval)
          }
        }, 1000)
      },
      async sendSms() {
        if (!this.form.phone) {
          this.$notify({
            color: 'danger',
            title: '手机号不能为空',
          })
          return
        }
        const data = {
          phone: this.form.phone,
          type: 'register',
        }
        await this.$s.auth.createVerifyCode(data).catch(err => {
          if (err.status == 100131) {
            this.$notify({
              color: 'danger',
              title: '该手机号已注册',
              text: '建议您返回登录，或者换个手机号重试'
            })
          }
          throw err
        })
        this.$notify({
          title: "验证码发送成功",
          text: "请查收您的短信"
        })
        this.startSendTimeout()
      },
      async registerUserJWt() {
        if (!this.agree) {
          this.$notify({
            color: 'danger',
            title: "请同意 《智慧溯源网使用协议及服务条款》",
          })
          return
        }
        if (this.form.password !== this.form.confirmPassword) {
          this.$notify({
            color: 'danger',
            title: "密码和确认密码输入不一致",
          })
          return
        }
        const payload = {
          phone: this.form.phone,
          code: this.form.code,
          password: this.form.password,
        }
        const user = await this.$s.auth.register(payload).catch(err => {
          if (err.status == 100131) {
            this.$notify({
              color: 'danger',
              title: '验证码错误',
            })
          }
          throw err
        })
        this.$notify({
          title: "注册成功"
        })


        this.$s.auth.serverCheck = false
        if (await this.$s.auth.isLogin()) {
          this.$s.auth.loginSuccess(user, this)
        }

      },
    }
  }
</script>
